// extracted by mini-css-extract-plugin
export default {"btn":"SubmitButton_btn__YH+W9","outlineBtn":"SubmitButton_outlineBtn__CW2SZ","touchbtn":"SubmitButton_touchbtn__NEPbF"};